import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import ScrollToTop from "@/components/ScrollToTop";
import CookieConsent from "@/components/CookieConsent";
import SmoothScroll from "@/components/motion/SmoothScroll";
import { CookieConsentProvider } from "@/hooks/useCookieConsent";
import HomePage from "@/pages/HomePage";
import DienstenPage from "@/pages/DienstenPage";
import ServicePage from "@/pages/ServicePage";
import CasesPage from "@/pages/CasesPage";
import OverOnsPage from "@/pages/OverOnsPage";
import ContactPage from "@/pages/ContactPage";
import AiScanPage from "@/pages/AiScanPage";
import SitemapPage from "@/pages/SitemapPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiesPage from "@/pages/CookiesPage";
import NotFoundPage from "@/pages/NotFoundPage";

const ServiceRoute = () => {
  const { slug } = useParams();
  return <ServicePage slug={slug} />;
};

const BlogPostRoute = () => {
  const { slug } = useParams();
  return <BlogPostPage slug={slug} />;
};

function App() {
  return (
    <div className="App">
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E5E5DF",
            color: "#0A0A0A",
          },
        }}
      />
      <CookieConsentProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Navigation />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/diensten" element={<DienstenPage />} />
              <Route path="/diensten/:slug" element={<ServiceRoute />} />
              <Route path="/cases" element={<CasesPage />} />
              <Route path="/over-ons" element={<OverOnsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/ai-scan" element={<AiScanPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostRoute />} />
              <Route path="/sitemap" element={<SitemapPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
            <Footer />
            <FloatingWhatsApp />
            <ScrollToTop />
            <CookieConsent />
          </SmoothScroll>
        </BrowserRouter>
      </CookieConsentProvider>
    </div>
  );
}

export default App;
